import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Global } from '@services/core/Global';

@Injectable({ providedIn: 'root' })
export class HelpDocumentService {
  private http = inject(HttpClient);
  private base = Global.url + 'V1';

  listByArticle(articleUuid: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.base}/help-articles/${articleUuid}/documents`);
  }

  create(articleUuid: string, data: { caption?: string | null; sortOrder?: number } = {}): Observable<any> {
    return this.http.post(`${this.base}/help-articles/${articleUuid}/documents`, data);
  }

  uploadNew(articleUuid: string, file: File, caption?: string | null): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    if (caption) formData.append('caption', caption);
    return this.http.post(`${this.base}/help-articles/${articleUuid}/documents/upload`, formData);
  }

  upload(uuid: string, file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.put(`${this.base}/help-documents/${uuid}/upload`, formData);
  }

  update(uuid: string, data: { caption?: string | null; sortOrder?: number }): Observable<any> {
    return this.http.patch(`${this.base}/help-documents/${uuid}`, data);
  }

  delete(uuid: string): Observable<any> {
    return this.http.delete(`${this.base}/help-documents/${uuid}`);
  }

  viewUrl(docOrLinkUuid: string): string {
    return `${this.base}/documents/view/${docOrLinkUuid}`;
  }
}
